/** The server owns time. We only measure how far the device clock is from it, and never trust the device alone. */

export function clockOffsetMs(serverNowIso: string, deviceNowMs: number = Date.now()): number {
  return new Date(serverNowIso).getTime() - deviceNowMs
}

export function remainingSeconds(deadlineIso: string, offsetMs: number, deviceNowMs: number = Date.now()): number {
  return Math.max(0, Math.ceil((new Date(deadlineIso).getTime() - (deviceNowMs + offsetMs)) / 1000))
}

export function formatClock(totalSeconds: number): string {
  const h = Math.floor(totalSeconds / 3600)
  const m = Math.floor((totalSeconds % 3600) / 60)
  const s = totalSeconds % 60
  const mm = String(m).padStart(2, '0')
  const ss = String(s).padStart(2, '0')
  return h > 0 ? `${h}:${mm}:${ss}` : `${mm}:${ss}`
}

export function minutesLabel(seconds: number): string {
  const m = Math.round(seconds / 60)
  return `${m} minute${m === 1 ? '' : 's'}`
}
